import { Link } from "react-router-dom"
import "./NewMedicineClinicPage.css"

const benefits = [
  { name: "Medication Review", description: "We'll check your new medicine works well with any others you take" },
  { name: "Side Effect Guidance", description: "Learn what to expect and how to manage any side effects" },
  { name: "Dosage Advice", description: "Understand when and how to take your medication correctly" },
  { name: "Lifestyle Tips", description: "Get advice on diet, exercise, and habits that may affect your medicine" },
  { name: "Follow-up Support", description: "We're here to answer questions as you adjust to your new treatment" },
]

const faqs = [
  {
    question: "What is the New Medicine Service?",
    answer: "The New Medicine Service is a free NHS service that supports patients who have been prescribed a new medicine for a long-term condition. We help ensure you understand your medication and get the best results from your treatment."
  },
  {
    question: "Who is eligible for this service?",
    answer: "This service is available to anyone who has recently been prescribed a new medicine for a long-term condition, such as high blood pressure, diabetes, asthma, or mental health conditions."
  },
  {
    question: "What happens during the consultation?",
    answer: "Our pharmacist will discuss your new medicine with you, explain how it works, when to take it, potential side effects, and answer any questions you may have. We'll also check it doesn't interact with any other medications you're taking."
  },
  {
    question: "How long does the consultation take?",
    answer: "A typical consultation lasts around 5-10 minutes, giving us time to address your questions and concerns."
  },
  {
    question: "Do I need to bring anything?",
    answer: "Please bring your new medication (or the prescription) and a list of any other medicines you currently take, including over-the-counter medications and supplements."
  },
]

function NewMedicineClinicPage() {
  return (
    <div className="new-medicine-clinic-page">
      <section className="nmc-hero">
        <h1>New Medicine Service</h1>
        <p className="nmc-tagline">
          Expert support when starting a new medication
        </p>
      </section>

      <section className="nmc-intro">
        <p>
          Starting a new medication can be daunting. Our New Medicine Service is here to help you
          understand your treatment and get the best possible results.
        </p>
        <p>
          Our trained pharmacists will take the time to explain everything you need to know about
          your new medicine, from how it works to managing any side effects.
        </p>
        <p className="nmc-highlight">
          A free NHS service to help you get the most from your medication.
        </p>
      </section>

      <section className="nmc-benefits">
        <h2>How We Can Help</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h3>{benefit.name}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="nmc-cta">
        <h2>Ready to Get Started?</h2>
        <p>
          Book a consultation with our pharmacist to discuss your new medication and ensure
          you're getting the best from your treatment.
        </p>
        <Link to="/services?service=new-medicine-clinic" className="button primary">
          Book a Consultation
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </Link>
      </section>

      <section className="nmc-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default NewMedicineClinicPage
